import { __rest } from "tslib";
/* eslint-disable prefer-arrow/prefer-arrow-functions */
// forked from https://github.com/jquense/uncontrollable/blob/master/src/index.ts
import { useCallback, useRef, useState } from 'react';
export function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    const wasPropRef = useRef(propValue !== undefined);
    const [stateValue, setState] = useState(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
     * If a prop switches from controlled to Uncontrolled
     * reset its value to the defaultValue
     */
    if (!isProp && wasProp && stateValue !== defaultValue) {
        setState(defaultValue);
    }
    return [
        isProp ? propValue : stateValue,
        useCallback((...args) => {
            const [value, ...rest] = args;
            const returnValue = handler === null || handler === void 0 ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [handler]),
    ];
}
export { useUncontrolledProp };
export function useUncontrolled(props, config) {
    return Object.keys(config).reduce((result, fieldName) => {
        const _a = result, _b = defaultKey(fieldName), defaultValue = _a[_b], _c = fieldName, propsValue = _a[_c], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + "", typeof _c === "symbol" ? _c : _c + ""]);
        // @ts-ignore-next-line
        const handlerName = config[fieldName];
        // @ts-ignore-next-line
        const [value, handler] = useUncontrolledProp(propsValue, defaultValue, props[handlerName]);
        return Object.assign(Object.assign({}, rest), { [fieldName]: value, [handlerName]: handler });
    }, props);
}
